import React from 'react';
import proptypes from 'prop-types';
import { Alert } from '@one-thd/sui-atomic-components';

const { string } = proptypes;

export const AlertMessage = ({ message = '', type = 'warning' }) => {

  return (
    <Alert status={type}>
      {message}
    </Alert>
  );
};

AlertMessage.displayName = 'SuperSkuAlertMessage';

AlertMessage.propTypes = {
  message: string,
  type: string,
};
